module.exports = __webpack_public_path__ + "static/giraffeprintcomforter-97028cd76abd60aedaead00c2a510b3a.png";